module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "body_introduction",
    attrs: {
      "id": "calibre_pb_60"
    }
  }, [_vm._v("This is my go-to breakfast Monday through Friday, and I never get tired of it! It’s nutrient dense, loaded with texture, and this version is 100% dairy free.")]), _vm._v(" "), _c('p', {
    staticClass: "body_instruction-next-para1"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("To cook the quinoa")]), _vm._v(", bring 2 cups of water to a boil. "), _c('span', {
    staticClass: "charoverride5"
  }, [_vm._v("Before adding the quinoa, rinse it under water to remove any debris,")]), _vm._v(" then boil for 13 minutes. Drain very well and add to a serving bowl along with the coconut cream and mix well. Top with granola, yogurt, fruit, "), _c('span', [_vm._v("and")]), _c('span'), _c('span', [_vm._v("enjoy!")])]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-centered-2col"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/image-337.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-centered-2col"
  }, [_vm._v("We eat grain-free and paleo "), _c('span', {
    staticClass: "shopping-tip-bold-red1"
  }, [_vm._v("granola")]), _vm._v(" at home, meaning no refined sugars or oats. My absolute favorite brand is Purely Elizabeth, followed by Autumn’s Gold at Costco. They have a great price. Search “FlavCity granola” on YouTube to learn more about shopping fo"), _c('span', [_vm._v("r")]), _c('span'), _c('span', [_vm._v("granola.")])]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-centered-2col"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/image-340.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-centered-2col"
  }, [_c('span', {
    staticClass: "shopping-tip-bold-red1"
  }, [_vm._v("Yogurt")]), _vm._v(" can be a minefield! I highly suggest searching “FlavCity Yogurt” on YouTube to learn more. If you want the best-quality yogurt, 100% grass-fed and full fat is the way to go. Stonyfield 100% grass-fed and Greek style is one of the best, and my favorite plant-based yogurt is plain Greek-style Kite Hill and vani"), _c('span', [_vm._v("lla")]), _c('span'), _c('span', [_vm._v("Lavva.")])]), _vm._v(" "), _c('p', {
    staticClass: "macro_macro-table-heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Macros per serving (makes 1):")])]), _vm._v(" "), _c('table', {
    staticClass: "table-style",
    attrs: {
      "id": "table002"
    }
  }, [_c('colgroup', {
    staticClass: "calibre5"
  }, [_c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('tbody', {
    staticClass: "calibre7"
  }, [_c('tr', {
    staticClass: "table-style1"
  }, [_c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("CALORIES")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("NET CARBS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("TOTAL CARBS")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("FAT")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("PROTEIN")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("FIBER")])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-style1"
  }, [_c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("460cal")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("48.9g")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("55.9g")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("21.9g")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("11.7g")])]), _vm._v(" "), _c('td', {
    staticClass: "table-style3"
  }, [_c('p', {
    staticClass: "macro_macro-table"
  }, [_vm._v("7.1g")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_61"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a956b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_037.vue
// module id = 168
// module chunks = 0